import React, { useState, useContext, useCallback } from 'react'
import './Styles/ShopProducts.css'
import { ShopContext } from '../Context/ShopContext'
import Item from '../Components/Item/Item'
import Filters from '../Components/Filters/Filters'

const ShopProducts = () => {

    const { all_products } = useContext(ShopContext)
    const [filteredProducts, setFilteredProducts] = useState([])
    const [showFilters, setShowFilters] = useState(false)
 
    const handleFilteredChange = useCallback((products) => {
        setFilteredProducts(products)
    }, [])


    return (
        <div className='shop-product'>

            {/* page header */}
            <div className="shop-product-header">
                <div className="shop-product-header-left">
                    <h1>All Products</h1>
                    <p className="shop-product-count">
                        {filteredProducts.length} of {all_products.length} products
                    </p>
                </div>
                {/* filter toggle - mobile view */}
                <button
                    className="shop-product-filter-toggle"
                    onClick={() => setShowFilters(p => !p)}
                >
                    {showFilters ? '✕ Hide Filters' : '⊞ Filters'}
                </button>
            </div>

            <div className="shop-product-body">

                {/* Filters sidebar */}
                <div className={`shop-product-filters-wrap ${showFilters ? 'shop-product-filters-wrap--open' : ''}`}>
                    <Filters
                        products={all_products}
                        lockedCategory={null}
                        onFilteredChange={handleFilteredChange}
                    />
                </div>

                {/* Product grid */}
                <div className="shop-product-grid-wrap">
                    {filteredProducts.length === 0 && all_products.length > 0 ? (
                        <div className="shop-product-no-results">
                            <p>No products match your filters.</p>
                            <p className="shop-product-no-results-hint">Try removing some filters to see more results.</p>
                        </div>
                    ) : (
                        <div className="shop-product-grid">
                            {filteredProducts.map(item => (
                                <Item key={item.id} id={item.id} name={item.name} discount_percentage={item.discount_percentage} available={item.available} images={item.images} price={item.price} old_price={item.old_price}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>
            
        </div>
    )
}

export default ShopProducts